import React, {useMemo} from 'react';
import tinycolor from 'tinycolor2';
import {getOptionColor} from '../../../getOptionColor';
import stylesheet from './Option.module.scss';

const Option = props => {
    const {option, percentage, flippedProps} = props,
        [backgroundColor, borderColor] = useMemo(
            () => [tinycolor(getOptionColor(option.id)).toHexString(), tinycolor(getOptionColor(option.id)).darken(0.2).toHexString()],
            [option]
        );

    return (
        <div className={stylesheet.option} {...flippedProps}>
            <div
                className={stylesheet.color}
                style={{
                    backgroundColor,
                    borderColor,
                }}></div>
            <div className={stylesheet.label}>
                {option.label} , <span className={stylesheet.percentage}>{Math.round(percentage * 10) / 10} %</span>
            </div>
        </div>
    );
};

export default Option;
